import React, { useState } from 'react';
import translate from '../../i18n/translate';

const TABS = [
  { id: 'metha',     keyLabel: 'faq-metha',     n: 4 },
  { id: 'ecosystem', keyLabel: 'faq-ecosystem', n: 4 },
  { id: 'research',  keyLabel: 'faq-research',  n: 4 },
  { id: 'dvbc',      keyLabel: 'faq-dvbc',      n: 4 },
];

/**
 * FAQ — single-open accordion. The currently open question is tracked at
 * this parent level so that opening another auto-closes the previous one.
 *
 * Each item is uniquely identified by `${tab}-${i}`.
 * Switching tabs collapses any open item (clean UX).
 */
function FaqItem({ qKey, aKey, isOpen, onToggle }) {
  return (
    <div className={'lv2-faq-item' + (isOpen ? ' open' : '')}>
      <button
        type="button"
        className="lv2-faq-q"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{translate(qKey)}</span>
        <span className="lv2-faq-toggle">+</span>
      </button>
      {/* Two-layer grid trick: outer animates grid-template-rows from 0fr to 1fr
          (natural height of inner). Inner has overflow:hidden + padding. */}
      <div className="lv2-faq-a">
        <div className="lv2-faq-a-inner">
          <p>{translate(aKey)}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [active, setActive] = useState('metha');
  const [openId, setOpenId] = useState(null); // single source of truth

  const switchTab = (tabId) => {
    setActive(tabId);
    setOpenId(null); // collapse any open item when changing tab
  };

  return (
    <section className="lv2-section" id="faq" style={{ paddingTop: 0 }}>
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('faq-ticker')}</span>
          <h2>{translate('faq-title')}</h2>
          <p className="sub">{translate('faq-sub')}</p>
        </div>

        <div className="lv2-faq-tabs">
          {TABS.map(t => (
            <button
              key={t.id}
              type="button"
              className={'lv2-faq-tab' + (active === t.id ? ' active' : '')}
              onClick={() => switchTab(t.id)}
            >
              {translate(t.keyLabel)}
            </button>
          ))}
        </div>

        {TABS.map(t => (
          <div key={t.id} style={{ display: active === t.id ? 'block' : 'none' }}>
            <div className="lv2-faq-list">
              {Array.from({ length: t.n }, (_, i) => i + 1).map(i => {
                const itemId = `${t.id}-${i}`;
                const isOpen = openId === itemId;
                return (
                  <FaqItem
                    key={itemId}
                    qKey={`faq-${t.id}-${i}-q`}
                    aKey={`faq-${t.id}-${i}-a`}
                    isOpen={isOpen}
                    onToggle={() => setOpenId(isOpen ? null : itemId)}
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
